export enum LocalStorageKey {
  BOOKING_ID = 'BOOKING_ID',
  PAGE_URL = 'PAGE_URL',
  CHECKOUT_ATTEMPT = 'CHECKOUT_ATTEMPT',
  GA_ADD_EXTRA_ITEMS = 'GA_ADD_EXTRA_ITEMS',
  BOOKING_CANCELLATION_ALLOWED = 'BOOKING_CANCELLATION_ALLOWED',
  BOOKING_CANCELLATION_INTO_VOUCHER_ALLOWED = 'BOOKING_CANCELLATION_INTO_VOUCHER_ALLOWED',
  OFFERS = 'OFFERS'
}
